import { injectable } from '@patsnap/tahiti-core/shared/inversify';
import { computePosition } from '@floating-ui/dom';
import type { PositioningStrategy } from '../positioning-strategies';

@injectable()
export class FloatUIPositioningStrategy implements PositioningStrategy {
    constructor(private options: Parameters<typeof computePosition>[2] = {}) {}

    async computePosition(reference: HTMLElement, popover: HTMLElement) {
        const { x, y } = await computePosition(reference, popover, this.options);
        return { x, y };
    }
}
